import { ReactNode, forwardRef } from 'react';

export type ModalProps = {
	children?: ReactNode;
	modalBoxClassName?: string;
	closeOnOutClick?: boolean;
	close?: () => void;
};

export const Modal = forwardRef<HTMLDialogElement, ModalProps>(
	({ children, modalBoxClassName, closeOnOutClick = true, close }, ref) => {
		const handleClickOutside = (e: React.MouseEvent<HTMLDialogElement>) => {
			if (closeOnOutClick && e.target === e.currentTarget) {
				close?.();
			}
		};

		return (
			<dialog
				ref={ref}
				onClick={handleClickOutside}
				className={`focus:outline-none p-0 rounded-md backdrop:bg-black/5 border border-grey-20 ${
					modalBoxClassName ?? ''
				}`}
			>
				{children}
			</dialog>
		);
	},
);
